import script from "./OnlinePill.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlinePill.vue?vue&type=script&setup=true&lang=js"

import "./OnlinePill.vue?vue&type=style&index=0&id=093bf9dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093bf9dd"]])

export default __exports__